<script setup>
import { useDisplay } from 'vuetify'

// mobile breakpoint
const { xs, smAndDown } = useDisplay()

const staticURLImg = useRuntimeConfig().public.staticURLImg
</script>

<template>
    <v-row id="webdesign" class="bg-grey-darken-4 justify-center slide-from-right rounded">
        <v-col cols="12" sm="10" class="my-16">
            <v-row dense>
                <v-col cols="12" md="4" class="d-flex">
                    <v-row dense>
                        <v-col cols="12" sm="6" md="12" lg="6">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + `exwb-ecomm.webp`"
                                height="100%"
                                cover
                                class="rounded st-box-shadow"
                                alt="E-Commerce website design"
                            >
                                <v-container
                                    class="d-flex pt-0 justify-center text-h6 text-center text-grey-darken-4 font-weight-medium st-text-shadow"
                                >
                                    <div>E-Commerce</div>
                                </v-container>
                            </v-img>
                        </v-col>
                        <v-col cols="12" sm="6" md="12" lg="6">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + `exwb-portfolio.webp`"
                                height="100%"
                                cover
                                class="rounded st-box-shadow"
                                alt="Blog, portfolio site design"
                            >
                                <v-container
                                    class="d-flex pt-0 justify-center text-h6 text-center text-grey-darken-4 font-weight-medium st-text-shadow"
                                >
                                    <div>Blogs, Portfolios</div>
                                </v-container>
                            </v-img>
                        </v-col>
                        <v-col cols="12" sm="6" md="12" lg="6">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + `exwb-services.webp`"
                                height="100%"
                                cover
                                class="rounded st-box-shadow"
                                alt="Product and services website design"
                            >
                                <v-container
                                    class="d-flex pt-0 justify-center text-h6 text-center text-grey-darken-4 font-weight-medium st-text-shadow"
                                >
                                    <div>Product & Services Websites</div>
                                </v-container>
                            </v-img>
                        </v-col>
                        <v-col cols="12" sm="6" md="12" lg="6">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + `exwb-mobile-app.webp`"
                                height="100%"
                                cover
                                class="rounded st-box-shadow"
                                alt="Mobile web app development"
                            >
                                <v-container
                                    class="d-flex pt-0 justify-center text-h6 text-center text-grey-darken-4 font-weight-medium st-text-shadow"
                                >
                                    <div>Mobile Web Apps</div>
                                </v-container>
                            </v-img>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="8" class="d-flex">
                    <v-row>
                        <!-- <v-col cols="12" class="text-h4 text-md-h3 text-center font-weight-medium st-text-shadow">
                            Your One-Stop Web Shop
                        </v-col> -->
                        <v-col cols="12" class="mt-4">
                            <app-section-header
                                :id="`wd1`"
                                :title="`Your One-Stop Shop for Web Design`"
                                :subtitle="``"
                            />
                        </v-col>
                        <v-col cols="12" class="pl-md-8 text-justify st-card-text">
                            We cater to a wide range of website needs. Whether you require a sleek portfolio, a blog, an
                            e-commerce website, or just need a refresh of your existing site to catch up with the
                            technology, we're here to assist you. Our team also possesses extensive experience in
                            setting up and customizing popular platforms like WordPress, Shopify, etc.
                        </v-col>
                        <v-col cols="12" class="my-4 text-center">
                            <v-btn
                                text="Contact Us"
                                to="/support"
                                size="x-large"
                                color="deep-orange-accent-4"
                                aria-label="Contact us"
                            ></v-btn>
                        </v-col>
                        <v-col cols="12" class="mt-4">
                            <app-section-header
                                :id="`wd2`"
                                :title="`Front-end and Back-end Development`"
                                :subtitle="``"
                                class="text-grey-darken-4"
                            />
                        </v-col>
                        <!-- <v-col cols="12" class="text-center text-h4 font-weight-medium st-text-shadow">
                            Front-end and Back-end Development
                        </v-col> -->
                        <v-col cols="12" class="pl-sm-8 text-justify st-card-text">
                            If you want to go for fullstack, look no further. This website showcases our expertise in
                            crafting modern web experiences. We built it on the latest technology stack, including
                            <span class="font-weight-medium text-blue">Nuxt.js, Vuetify, and Vue.js</span> for a dynamic
                            and visually appealing frontend. The backend is powered by
                            <span class="font-weight-medium text-blue">
                                Symfony, API Platform, MariaDB, GraphQL, and REST APIs,
                            </span>
                            ensuring scalability and secure data management.
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + `exwb-ga4-badge.webp`"
                                height="100%"
                                :width="smAndDown ? '30%' : '20%'"
                                cover
                                class="mx-auto"
                                alt="Google analytics certificate badge"
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
